import React from 'react';

const CookiePolicy: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold mb-6">Cookie-Richtlinie</h1>
            <p className="text-gray-600 text-lg">
              Informationen zur Verwendung von Cookies auf unserer Website.
            </p>
          </div>
        </div>
      </section>
      
      {/* Cookie Policy Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-3xl">
          <div className="prose prose-lg max-w-none">
            <h2>Cookie-Richtlinie</h2>
            <p>
              Diese Cookie-Richtlinie erläutert, was Cookies sind und wie wir sie verwenden. Sie sollten diese Richtlinie lesen, um zu verstehen, was Cookies sind, wie wir sie verwenden, welche Arten von Cookies wir verwenden, welche Informationen wir mit Cookies sammeln und wie wir diese Informationen verwenden.
            </p>
            <br></br>
            <h3>1. Was sind Cookies?</h3>
            <p>
              Cookies sind kleine Textdateien, die auf Ihrem Computer oder mobilen Gerät gespeichert werden, wenn Sie eine Website besuchen. Sie werden weithin verwendet, um Websites funktionsfähig zu machen oder effizienter zu arbeiten, sowie um Informationen an die Eigentümer der Website zu liefern.
            </p>
            <br></br>
            <h3>2. Wie verwenden wir Cookies?</h3>
            <p>
              Unsere Website verwendet Cookies, um Sie von anderen Nutzern unserer Website zu unterscheiden. Dies hilft uns, Ihnen ein gutes Erlebnis zu bieten, wenn Sie auf unserer Website surfen, und ermöglicht es uns auch, unsere Website zu verbessern.
            </p>
            <br></br>
            <h3>3. Welche Arten von Cookies verwenden wir?</h3>
            <p>
              <strong>Notwendige Cookies</strong>: Diese Cookies sind für das Funktionieren der Website unerlässlich und können in unseren Systemen nicht ausgeschaltet werden.
            </p>
            <p>
              <strong>Funktionale Cookies</strong>: Diese Cookies ermöglichen es der Website, verbesserte Funktionalität und Personalisierung zu bieten.
            </p>
            <p>
              <strong>Analytische Cookies</strong>: Diese Cookies erlauben es uns, Besuche und Verkehrsquellen zu zählen, damit wir die Leistung unserer Website messen und verbessern können.
            </p>
            <br></br>
            <h3>4. Wie kann ich Cookies kontrollieren?</h3>
            <p>
              Sie können Cookies über Ihre Browsereinstellungen kontrollieren und löschen. Die meisten Browser erlauben es Ihnen, Cookies abzulehnen oder zu akzeptieren, indem Sie Ihre Browsereinstellungen ändern. Die Methoden zum Ablehnen von Cookies können von Browser zu Browser variieren, daher sollten Sie das Hilfemenü Ihres Browsers konsultieren, um mehr zu erfahren.
            </p>
            <p>
              Bitte beachten Sie, dass das Blockieren oder Löschen von Cookies die Funktionalität unserer Website beeinträchtigen und dazu führen kann, dass einige Dienste nicht mehr funktionieren.
            </p>
            <br></br>
            <h3>5. Änderungen unserer Cookie-Richtlinie</h3>
            <p>
              Wir können diese Richtlinie von Zeit zu Zeit aktualisieren, indem wir eine neue Version auf unserer Website veröffentlichen. Sie sollten diese Seite gelegentlich überprüfen, um sicherzustellen, dass Sie mit den Änderungen einverstanden sind.
            </p>
            <br></br>
            <p>Stand: Januar 2026</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;